import { css, type Theme } from "@emotion/react";
import { typography } from "aviary-tokens";

export const lightText = (theme: Theme) => css`
  font-weight: ${typography.weightBase};

  strong {
    color: ${theme.text.body};
    font-weight: bold;
  }
`;

export const container = css`
  padding: 1rem 0;
`;

export const separator = css`
  margin: 0.5rem 0;
`;
